import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useAuth } from "@/hooks/useAuth";
import { CombinedMenuButton } from "@/components/navigation/CombinedMenuButton";
import { ComponentErrorBoundary } from "@/components/error/ComponentErrorBoundary";

function HeaderButtonsContent() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while auth is being determined
  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-8 w-32 animate-pulse rounded-full bg-gray-200" />
        <div className="h-8 w-24 animate-pulse rounded-full bg-gray-200" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          className="rounded-full bg-white px-4 py-2 font-medium text-gray-800"
          onClick={() => navigate("/login")}
        >
          {t?.common?.login ?? "Login"}
        </Button>
        {!import.meta.env.PROD && (
          <Button
            className="rounded-full bg-primary px-4 py-2 font-medium text-primary-foreground"
            onClick={() => navigate("/signup")}
          >
            {t?.common?.signup ?? "Sign Up"}
          </Button>
        )}
      </div>
    );
  }

  return (
    <ComponentErrorBoundary fallbackMessage="Menu unavailable">
      <CombinedMenuButton />
    </ComponentErrorBoundary>
  );
}

export function HeaderButtons() {
  return (
    <ComponentErrorBoundary fallbackMessage="Header buttons unavailable">
      <HeaderButtonsContent />
    </ComponentErrorBoundary>
  );
}
